import {DisplayName, TableIndex} from '@yasc/yasc-material-components';

export class ContactPersonDetailRes {
    id!: number
    @DisplayName('general_title')
    @TableIndex(1)
    title!: string;
    @DisplayName('general_salutation')
    @TableIndex(0)
    salutations!: number;
    @DisplayName('general_firstName')
    @TableIndex(2)
    firstName!: string;
    @DisplayName('general_lastName')
    @TableIndex(3)
    lastName!: string;
    @DisplayName('general_email')
    @TableIndex(4)
    email!: string;
    @DisplayName('general_phone')
    @TableIndex(5)
    phone!: string;
    @DisplayName('general_mobile')
    @TableIndex(6)
    mobile!: string;
    @DisplayName('general_department')
    department!: string;
    @DisplayName('general_company')
    @TableIndex(7)
    companyId!: number;
}


export class ContactPersonCreateReq {
    title: string = "";
    firstName: string = "";
    lastName: string = "";
    salutations: number = 0;
    email: string = "";
    phone: string = "";
    mobile: string = "";
    department: string = "";
    companyName: string = "";
    companyId!: number

    constructor(contact?: ContactPersonDetailRes) {
        if (contact == undefined) return;
        this.firstName = contact.firstName;
        this.title = contact.title;
        this.lastName = contact.lastName;
        this.salutations = contact.salutations;
        this.email = contact.email;
        this.phone = contact.phone
        this.companyId = contact.companyId;
    }
}

export class ContactPersonUpdateReq extends ContactPersonCreateReq {
    id?: number

    constructor(contact?: ContactPersonDetailRes) {
        super(contact);
        this.id = contact?.id
    }
}